export default {
  kiosk: {
    温馨提示: "Reminder",
    继续点餐: "Continue ordering",
    长时间未操作:
      "After being idle for a long time, it will automatically return to the homepage in {second} seconds",
  },
};
